// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".sales-report-card.card .card-header-title[data-v-f482f0a8] {\n  font-size: 14px;\n  text-transform: uppercase;\n  font-weight: 700;\n}\n.tab-content[data-v-f482f0a8] {\n  height: auto !important;\n}", ""]);
// Exports
module.exports = exports;
